module.exports = __webpack_public_path__ + "img/hero-schedule-today.75dcb54d.jpg";